if (typeof ($.advertising) == 'undefined') {
    $.advertising = {};
}

if (typeof ($.advertising.clientCenter) == 'undefined') {
    $.advertising.clientCenter = {};
}

$.advertising.checkForScreenSize = true;
$.advertising.smallScreenThresholdWidth = 1500;

window.GetStatusAlerts = function (accountId, accountStatusUrl, alertContainer) {
    var url = $.advertiser.setUrlParameter('aid', accountId, accountStatusUrl);
    var container = $('#' + alertContainer);
    container.text('');
    $.advertiser.ajaxGet({
        url: url,
        ignoreBeforeAjax: true,
        onSuccess: function (data) {
            if (!_.isObject(data)) {
                container.html(data);
            }
        }
    });
};

/*
    This function is called from private\UI\ClientCenter\Customer\Microsoft.ClientCenter.UI.Customer\Views_Next\Accounts\SelectionInfo.cshtml
    It generates an empty popup, gets the popup content generated by the server (in above file) inside div with id 'managingCustomersPopupContentId'
    and adds it to the popup.
*/
window.ShowManagingCustomers = function (managingCustomersPopupButton, managingCustomersPopupId, managingCustomersPopupContentId) {
    var popupCallback = function() {        
        var popupContent = $('#' + managingCustomersPopupContentId).html();
        $('#' + managingCustomersPopupId).empty().html(popupContent);
    };
    
    $.gridPopup.clickEvent({ target: managingCustomersPopupButton }, popupCallback, managingCustomersPopupId, '', false);
};

function adjustforSmallScreen(width) {
    if (!($.advertising && $.advertising.checkForScreenSize)) {
        return;
    }
    width = parseInt(width);
    if (width < $.advertising.smallScreenThresholdWidth) {
        $("body").addClass("smallScreen");
    }
    else {
        $("body").removeClass("smallScreen");
    }
}

$.advertising.clientCenter.navigation = {
    getItemClass: function(item) {
        var cssClass = "rest";
        if (item.IsFirst) {
            cssClass = "first";
        }
        else if (item.IsLast) {
            cssClass = "last";
        }
        cssClass += item.IsActive ? " active" : "";
        return cssClass;
    },

    getItemLinkClass: function(item) {
        var cssClass = item.IsFirst ? "left" : "";
        return cssClass;
    }
};

$.advertising.clientCenter.popup = {
    alert: function (options) {
        options.className = 'alertPopup';
        options.buttons = [{
            class: 'ui-state-highlight',
            text: options.confirmButtonText,
            click: function () {
                $(this).dialog('close');
            },
        }];
        if (options.buttonId) {
            options.buttons[0].id = options.buttonId;
        }
        options.close = function () {
            if (options.callBack) {
                options.callBack();
            }
        };

        this.openPopup(options);
    },
    confirm: function (options) {
        options.className = 'confirmPopup';
        options.buttons = [{
                class: 'ui-state-highlight ok',
                text: options.confirmButtonText,
                click: function () {
                    if (options.confirmCallBack) {
                        options.confirmCallBack();
                    }

                    $(this).data('click-state', 'ok')
                           .dialog('close');
                }
            }, {
                class: 'cancel',
                text: options.cancelButtonText,
                click: function () {
                    $(this).dialog('close');
                }
            }
        ];
        options.open = function () {
            var dlgWidget = $(this).dialog('widget');
            // fix close button placement for long titles
            dlgWidget.find('.ui-dialog-titlebar-close').prependTo(dlgWidget.find('.ui-dialog-titlebar'));
            // focus on neutral buttons by default
            dlgWidget.find('.ui-dialog-buttonpane button.cancel').focus();
        };
        options.close = function () {
            if ($(this).data('click-state') != 'ok') {
                if (options.cancelCallBack) {
                    options.cancelCallBack();
                }
            }

            $(this).removeData('click-state');
        }

        this.openPopup(options);
    },
    openPopup: function (options) {
        var dialog;
        if (options.id) {
            dialog = $('#' + options.id);
        }

        if (!(dialog && dialog.size())) {
            dialog = $('<div>', {
                id: options.id,
            }).appendTo(document.body);
        }

        if (options.text) {
            dialog.html(options.text);
        }

        if (dialog.data('ui-dialog')) {
            dialog.dialog('open');
        } else {
            dialog.dialog({
                autoOpen: true,
                width: 400,
                title: options.title,
                dialogClass: 'bingads-dlg ' + options.className,
                modal: true,
                closeOnEscape: (options.closeOnEscape === undefined) ? true : options.closeOnEscape,
                buttons: options.buttons,
                draggable: false,
                resizable: false,
                zIndex: 2000,
                close: options.close,
                open: options.open,
            });
        }
    }
};

$.advertising.clientCenter.deferAction = function (action) {
    if (action) {
        if (window.addEventListener) {
            window.addEventListener('load', action, false);
        }
        else if (window.attachEvent) {
            window.attachEvent('onload', action);
        }
        else {
            var existingOnloadHandler = window.onload;
            window.onload = function() {
                if (existingOnloadHandler) {
                    existingOnloadHandler();
                }
                
                action();
            }
        }
    }
};

$(function () {
    var globalNumberFormat = window.globalNumberFormat;
    adjustforSmallScreen($(this).width());
    $(window).resize(function () {
        adjustforSmallScreen($(this).width());
    });

    if (globalNumberFormat) {
        var thousandSeparator = globalNumberFormat.substring(1, 2);
        var decimalSeparator = globalNumberFormat.substring(5, 6);
        var numberRegEx = new RegExp('^-?(?:\\d+|\\d{1,3}(?:\\' + thousandSeparator + '\\d{3})+)(?:\\' + decimalSeparator + '\\d+)?$');
        $.extend($.validator.methods, {
            range: function (value, element, param) {
                if (this.optional(element)) {
                    return true;
                }
                var val = parseFloat(value.replace(thousandSeparator, ',').replace(decimalSeparator, '.'));
                return (val >= param[0] && val <= param[1]);
            },
            number: function (value, element) {
                return this.optional(element) || numberRegEx.test(value);
            }
        });
    }
});